module.exports = __webpack_public_path__ + "img/design.9dc00778.png";